// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-jxfzcx-tyJxfzcx-index-main_right_content-3LwBr","table":"components-tjcx-jxfzcx-tyJxfzcx-index-table-3psCe"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/jxfzcx/tyJxfzcx/index.css
// module id = 2309
// module chunks = 0